export default {
    0: {
        fetch_fail: '网络繁忙，请稍后再试',
        empty_list: '暂无邀请记录'
    },
    1: {
        fetch_fail: '網絡繁忙，請稍後再試',
        empty_list: '暫無邀請記錄'
    },
    2: {
        fetch_fail: 'Network busy, please try again later',
        empty_list: 'No invitation records yet'
    },
    5: {
        fetch_fail: 'ネットワークが混雑しています。後でもう一度お試しください。',
        empty_list: '招待記録はまだありません'
    }
};
